import React from "react";
import SolidAddButton from "components/ui/Button/SolidAddButton/SolidAddButton";
import Heading from "components/ui/Heading/Heading";
import { FOLLOW_UP_TASK_ACTIONS } from "../enum";
import FollowUpCollectionAccessControl from "../../FollowUpCollectionAccessControl/FollowUpCollectionAccessControl";

const { ADD_NEW_FOLLOW_UP_TASK } = FOLLOW_UP_TASK_ACTIONS;

const FollowUpTasksViewHeading = ({ handleActionModal, followUpData }) => {
    const { name } = followUpData || {};

    return (
        <>
            <div className='agent-follow-up__heading'>
                <div>
                    <Heading headingText={name} />
                </div>
                <div>
                    <FollowUpCollectionAccessControl>
                        <SolidAddButton
                            btnText='Add New Task'
                            onClick={() =>
                                handleActionModal(ADD_NEW_FOLLOW_UP_TASK)
                            }
                        />
                    </FollowUpCollectionAccessControl>
                </div>
            </div>
        </>
    );
};

export default FollowUpTasksViewHeading;
